export default "__VITE_ASSET___4$QD2XL__"